import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

export type CorporateLocation = 'pittsburgh' | 'tampa';

interface LocationContextType {
  selectedLocation: CorporateLocation;
  setSelectedLocation: (location: CorporateLocation) => void;
  locationLabel: string;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

interface LocationProviderProps {
  children: ReactNode;
}

export const LocationProvider: React.FC<LocationProviderProps> = ({ children }) => {
  // Initialize from sessionStorage or default to 'pittsburgh'
  const [selectedLocation, setSelectedLocationState] = useState<CorporateLocation>(() => {
    const stored = sessionStorage.getItem('chillerSelectedLocation');
    return (stored as CorporateLocation) || 'pittsburgh';
  });

  const setSelectedLocation = (location: CorporateLocation) => {
    setSelectedLocationState(location);
    sessionStorage.setItem('chillerSelectedLocation', location);
  };

  const locationLabel = selectedLocation === 'pittsburgh' ? 'Pittsburgh' : 'Tampa';

  return (
    <LocationContext.Provider
      value={{
        selectedLocation,
        setSelectedLocation,
        locationLabel,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = (): LocationContextType => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};
